import Vue from 'vue'

const STORAGE_KEY = 'speedCurveSettings'
const bus = new Vue()

export const SPEED_COLOR_STOPS = ['#E53935', '#43A047', '#1E88E5']
export const SPEED_SLIDER_MAX = 120

export const DEFAULT_SPEED_CURVE_SETTINGS = {
  speedNodes: [60, 89],
  overspeedLimit: 80
}

function normalizeNodes(nodes) {
  let n1 = Number(Array.isArray(nodes) ? nodes[0] : 60)
  let n2 = Number(Array.isArray(nodes) ? nodes[1] : 89)
  if (!Number.isFinite(n1)) n1 = 60
  if (!Number.isFinite(n2)) n2 = 89
  n1 = Math.max(1, Math.min(SPEED_SLIDER_MAX - 1, Math.round(n1)))
  n2 = Math.max(n1 + 1, Math.min(SPEED_SLIDER_MAX, Math.round(n2)))
  return [n1, n2]
}

export function normalizeSpeedCurveSettings(raw) {
  const base = raw && typeof raw === 'object' ? raw : {}
  let limit = Number(base.overspeedLimit != null ? base.overspeedLimit : DEFAULT_SPEED_CURVE_SETTINGS.overspeedLimit)
  if (!Number.isFinite(limit) || limit <= 0) limit = DEFAULT_SPEED_CURVE_SETTINGS.overspeedLimit
  limit = Math.round(limit)
  return {
    speedNodes: normalizeNodes(base.speedNodes),
    overspeedLimit: limit
  }
}

export function getSpeedCurveSettings() {
  if (typeof window === 'undefined' || !window.localStorage) {
    return { ...DEFAULT_SPEED_CURVE_SETTINGS, speedNodes: [...DEFAULT_SPEED_CURVE_SETTINGS.speedNodes] }
  }
  try {
    const saved = window.localStorage.getItem(STORAGE_KEY)
    if (!saved) {
      return { ...DEFAULT_SPEED_CURVE_SETTINGS, speedNodes: [...DEFAULT_SPEED_CURVE_SETTINGS.speedNodes] }
    }
    return normalizeSpeedCurveSettings(JSON.parse(saved))
  } catch (e) {
    return { ...DEFAULT_SPEED_CURVE_SETTINGS, speedNodes: [...DEFAULT_SPEED_CURVE_SETTINGS.speedNodes] }
  }
}

export function saveSpeedCurveSettings(next) {
  const normalized = normalizeSpeedCurveSettings(next)
  if (typeof window !== 'undefined' && window.localStorage) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(normalized))
    } catch (e) {
      /* ignore */
    }
  }
  bus.$emit('change', normalized)
  return normalized
}

export function onSpeedCurveSettingsChange(handler) {
  bus.$on('change', handler)
  return () => bus.$off('change', handler)
}
